import React from "react";
import type { IconProps } from "types";

const BankCard = ({width="20", height="20", color="currentColor"}: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83325 5.41699V3.75033C5.83325 3.29009 6.20634 2.91699 6.66659 2.91699H17.4999C17.9602 2.91699 18.3333 3.29009 18.3333 3.75033V11.2503C18.3333 11.7106 17.9602 12.0837 17.4999 12.0837H16.6666"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 7.91699H2.50008C2.03984 7.91699 1.66675 8.29009 1.66675 8.75033V16.2503C1.66675 16.7106 2.03984 17.0837 2.50008 17.0837H13.3334C13.7937 17.0837 14.1667 16.7106 14.1667 16.2503V8.75033C14.1667 8.29009 13.7937 7.91699 13.3334 7.91699Z"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66675 11.667H14.1667"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 9.58301V14.583"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66675 9.58301V14.583"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58325 14.167H7.91659"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4167 14.167H11.2501"
      stroke={color}
      strokeWidth="1.37931"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(BankCard);
